<div class="container">
  <!-- <div class="app-top">
  <button (click)='toggleVisible()'>toggle visible</button>
  <button (click)='toggleWeekends()'>toggle weekends</button>
  <button (click)='gotoPast()'>go to a date in the past</button>
</div> -->
@if (calendarVisible) {
  <div class="app-calendar">
    <!--<full-calendar
    #calendar
    defaultView="dayGridMonth"
      [header]="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
			}"
    [locale]="spLocal"
    [themeSystem]="theme"
    [plugins]="calendarPlugins"
    [weekends]="calendarWeekends"
    [events]="calendarEvents"
    (dateClick)="handleDateClick($event)"
  ></full-calendar>-->
</div>
}
</div>
